import { Popup } from './Popup.js';
// CLASS PopupWithImage
export class PopupWithImage extends Popup {
    constructor({ popupSelector }) {
        super(popupSelector);
        // Finding constants based on arguments of method:
        this._popupWithImage = this._popup.querySelector('.popup__img');
        this._imageHeading = this._popup.querySelector('.popup__heading');
    }

    open({ link, name }) {
        // Inheritance from parent popup:
        super.open();
        // Add new functionality to open-method for current popup:
        this._popupWithImage.setAttribute('src', link)
        this._popupWithImage.setAttribute('alt', name);
        this._imageHeading.textContent = name;
    }
}